import { render, staticRenderFns } from "./NewsCategoryCards.vue?vue&type=template&id=a3f4d542&"
import script from "./NewsCategoryCards.vue?vue&type=script&lang=js&"
export * from "./NewsCategoryCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports